/**
 * How a release's status reads, and what colour it wears — copied from the
 * command center (`crm/pages/releases/release-status.ts`) so a status that is
 * "Released" green there is "Released" green here.
 */
export const RELEASE_STATUS_COLOR: Record<string, "success" | "info" | "warning" | "default"> = {
  released: "success",
  in_progress: "info",
  planned: "warning",
  archived: "default",
};

const RELEASE_STATUS_LABEL: Record<string, string> = {
  released: "Released",
  in_progress: "In progress",
  planned: "Planned",
  archived: "Archived",
};

export function statusLabel(status: string): string {
  return RELEASE_STATUS_LABEL[status] ?? status;
}
